'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIntrospectionEnabled = exports.isIntrospectionEnabled = undefined;

var _react = require('react');

var usesIntrospection = _react.PropTypes.any.__INTROSPECTION__;

/**
 * @return {boolean}
 */
var isIntrospectionEnabled = exports.isIntrospectionEnabled = function isIntrospectionEnabled() {
  return usesIntrospection;
};

/**
 * Override for testing logic dependent on isIntrospectionEnabled()
 * @param {boolean} newUsesIntrospection
 */
var setIntrospectionEnabled = exports.setIntrospectionEnabled = function setIntrospectionEnabled(newUsesIntrospection) {
  usesIntrospection = newUsesIntrospection;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/utils/propTypes/internal/introspection.js
// module id = 174
// module chunks = 171